import { Flex } from "@/components/atoms/flex";
import { PanelHeaderProps } from "./types";
import { useStyle } from "./style";
import { mergeClasses } from "@fluentui/react-components";

export const PanelHeader = (props: PanelHeaderProps) => {
	const classes = useStyle();

	return (
		<Flex
			vAlign="center"
			hAlign="space-between"
			className={mergeClasses(classes.root, props.className)}
		>
			{props.left}
			{props.right}
		</Flex>
	);
};
